import api from './api';

export const getLeadInterestReport = (params: any) => {
  return api.get('/reports/lead-interest', { params });
};

/**
 * Fetches a list of all active sales users specifically for report filters.
 */
export const getSalesForReportFilter = async () => {
  try {
    // This endpoint is specifically for managing sales users
    const response = await api.get('/sales-management/users', {
      params: {
        limit: 1000, // Fetch a large number to get all sales
        is_active: true,
      },
    });
    // The actual user data is nested under response.data.data
    return response.data;
  } catch (error) {
    console.error('Failed to fetch sales users for report filter:', error);
    throw error;
  }
};
